<template>
  <div>
    <ApplicationHome v-if="!state && getData"></ApplicationHome>
    <ApplicationStates v-if="state && getData" :info="info"></ApplicationStates>
  </div>
</template>

<script>
import ApplicationHome from "./applicationHome.vue";
import ApplicationStates from "./applicationStates.vue";
export default {
  name: "application",
  data() {
    return {
      state: "",
      getData: false,
      info: "",
    };
  },
  components: {
    ApplicationHome,
    ApplicationStates,
  },
  mounted() {
    this.util.showLoading();
    this.getAuditStatus();
  },
  methods: {
    getAuditStatus() {
      this.$post(
        "gart-common-api/api/cmn/auditing/queryByAuditingStatus",
        {}
      ).then((res) => {
        this.util.hideLoading();
        if (res.code == 1) {
          if (res.data.rtncode == 1) {
            this.getData = true;
            this.state = res.data.status;
            this.info = res.data;
          } else {
            this.util.toast({ msg: res.data.rtnmsg });
          }
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
  },
};
</script>

<style>
</style>